export enum PathParam {
  Variant = 'variant',
}

export default PathParam;
